module.exports = __webpack_public_path__ + "img/roundBookmark.cb3d0013.svg";